import React from 'react';
import { useTranslation } from 'react-i18next';
import { useApplyDryBatchValues } from '../utils/previous-values-manager';
import BatchSelectionModal from './BatchSelectionModal';

interface DryUpLoadModalProps {
  show: boolean;
  onHide: () => void;
  currentValues: any;
  setValues: (values: any) => void;
  setInitialValues?: (values: any) => void;
}

const DryUpLoadModal: React.FC<DryUpLoadModalProps> = (props) => {
  const { t } = useTranslation();
  const applyDryBatchValues = useApplyDryBatchValues();

  const alertMessage = (
    <>
      <strong>{t('Note:')}</strong> {t('This will copy materials from the selected batch but exclude all water materials. Use this to create a dry load based on a previous batch.')}
    </>
  );

  return (
    <BatchSelectionModal
      {...props}
      title={t('Dry Up Load')}
      submitButtonText={t('Apply Dry Materials Only')}
      submitButtonStyle="warning"
      alertMessage={alertMessage}
      alertStyle="info"
      onApplyBatch={applyDryBatchValues}
    />
  );
};

export default DryUpLoadModal;
